import { useCampaignResults } from '../../api/CampaignResultAPI';
import { useParams } from 'react-router-dom';

export const useQuestionShareUrl = (
  isCampaignResults?: boolean
): string | undefined => {
  const { campaignIdentifier } = useParams<{ campaignIdentifier?: string }>();
  const { data: campaignResults = [] } = useCampaignResults(campaignIdentifier);

  if (isCampaignResults) {
    return `${window.location.origin}${window.location.pathname}`;
  }

  return campaignResults.length
    ? `${window.location.origin}/insights_platform/results/${campaignResults[0].identifier}`
    : undefined;
};
